import { c as _c } from "react/compiler-runtime";
import logoFullDark from "#assets/icons/ff-logo-full-dark.png";
import logoFullWhite from "#assets/icons/ff-logo-full-white.png";
import logoIconDark from "#assets/icons/ff-logo-icon-dark.png";
import logoIconWhite from "#assets/icons/ff-logo-icon-white.png";
import { cn } from "../../lib/utils";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function FFLogo(t0) {
  const $ = _c(23);
  const {
    className,
    variant: t1,
    inverted: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const inverted = t2 === undefined ? false : t2;
  const fullSrc = inverted ? logoFullWhite : logoFullDark;
  const iconSrc = inverted ? logoIconWhite : logoIconDark;
  if (variant === "full") {
    let t3;
    if ($[0] !== className) {
      t3 = cn("h-auto w-auto max-w-[120px] md:max-w-[150px]", className);
      $[0] = className;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== fullSrc || $[3] !== t3) {
      t4 = /*#__PURE__*/_jsx("img", {
        src: fullSrc,
        alt: "Faster Forward",
        className: t3
      });
      $[2] = fullSrc;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (variant === "icon") {
    let t3;
    if ($[5] !== className) {
      t3 = cn("h-8 w-8", className);
      $[5] = className;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== iconSrc || $[8] !== t3) {
      t4 = /*#__PURE__*/_jsx("img", {
        src: iconSrc,
        alt: "Faster Forward",
        className: t3
      });
      $[7] = iconSrc;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t3;
  if ($[10] !== className) {
    t3 = cn("hidden md:block h-auto w-auto max-w-[120px] md:max-w-[150px]", className);
    $[10] = className;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== fullSrc || $[13] !== t3) {
    t4 = /*#__PURE__*/_jsx("img", {
      src: fullSrc,
      alt: "Faster Forward",
      className: t3
    });
    $[12] = fullSrc;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== className) {
    t5 = cn("block md:hidden h-8 w-8", className);
    $[15] = className;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== iconSrc || $[18] !== t5) {
    t6 = /*#__PURE__*/_jsx("img", {
      src: iconSrc,
      alt: "Faster Forward",
      className: t5
    });
    $[17] = iconSrc;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t4, t6]
    });
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}